
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="List" -->
			 <el-form-item>
				  <el-select v-model="orderState"   style="margin-left: 20px;" placeholder="状态" :collapse-tags="false">
                     <el-option v-for="item in options" :key="item.value"  :label="item.label" :value="item.value">
                      </el-option>
                   </el-select>
			 </el-form-item>
            	<el-form-item>
					<el-input  v-model="filters.OrderNumber"  @keyup.enter.native="List" placeholder="订单号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="List" placeholder="购票人"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="List" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="ConsumptionBusiness">扫码核销</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="ListData" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column type="id" width="60" hidden>
			</el-table-column> -->
			<!-- <el-table-column prop="Number" label="教练编号" width="120" sortable>
			</el-table-column> -->
			<el-table-column prop="OrderNumber" label="订单号" width="250" sortable>
			</el-table-column>
			<el-table-column prop="OrderMoney" label="金额" width="100" sortable>
			</el-table-column>
			<el-table-column prop="CreationTime" label="下单时间" width="200"  sortable>
			</el-table-column>			
			<el-table-column prop="ChangeTime" label="支付时间" width="200"  sortable>
			</el-table-column>
			<el-table-column prop="MemberName" label="购票人" width="150"  sortable>
			</el-table-column>
  			<el-table-column prop="Sex" label="性别" width="100" :formatter="formatSex"   sortable>
			</el-table-column> 
            <el-table-column prop="Phone" label="联系电话" width="150"  sortable>
			</el-table-column> 
            <el-table-column prop="IdCardNumber" label="身份证号码" width="200"  sortable>
			</el-table-column> 
            <el-table-column prop="IsUse" label="是否使用" width="150" :formatter="formatIsUse" sortable>
			</el-table-column> 
             <el-table-column prop="UseTime" label="使用时间" width="200"  sortable>
			</el-table-column> 
                     
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
            <el-table-column prop="State" label="状态" width="120" sortable fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="danger" size="medium" v-if="scope.row.OrderState==0">未支付</el-tag>
                  <el-tag type="success" size="medium" v-if="scope.row.OrderState==1">已支付</el-tag>
                  <el-tag type="warning" size="medium" v-if="scope.row.OrderState==2">已取消</el-tag>
                  <el-tag type="info" size="medium" v-if="scope.row.OrderState==3">手动核销</el-tag>
				  <el-tag type="primary" size="medium" v-if="scope.row.OrderState==4">扫码核销</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column label="操作" width="120" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" type="warning" v-if="scope.row.OrderState==1" @click="verification(scope.row)">核销</el-button>
                    <el-button size="small" type="warning" v-else :disabled="true" @click="verification(scope.row)">核销</el-button>
                 <!-- <el-button size="small" type="warning"  @click="see(scope.row)">查看图片</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-tag>当前有{{Count}}位教练</el-tag> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>	
	    <!-- 查看图片 -->
        <!-- <el-dialog title="新增" v-model="addFormVisible">
			<img  ref="selectlogoPictureImg" :src="imgUrl" >
		</el-dialog> -->
 <el-dialog  title="请检查扫码枪是否连接" custom-class style="width:100%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;"  v-model="Machine" @close="closeDialog" :close-on-click-modal="false">
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
      <!-- <img v-bind:src="a" class="image"> -->
      <div >     
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
        <!-- <span>请检查读卡器</span> -->		        
				<el-form-item >
					<input class="input" ref="siteInput"  v-model="inputValue"  clearable @keyup.enter="BusinessHandle" :autofocus="focusvalue" placeholder="请扫码"></input>
				</el-form-item>
				<el-form-item>
					<el-button  type="primary" v-on:click="BusinessHandle" icon="el-icon-search">确认扫码</el-button>
				</el-form-item>				
			</el-form>			
		</el-col>		 				 						
      </div>	  
      </el-card>
     </el-col>
     </el-row>	
    </el-dialog>
  <!-- 重置界面 -->
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import { TicketOrderList, addTicket,editTicket ,TicketOrderChangeState,SweepCode } from '../../api/api';

	export default {
		data() {
			return {
				filters: {
                    Name: '',
                    OrderNumber:''
				},
				orderState:'',
		options: [{
          value: '0',
          label: '未支付'
        }, {
          value: '1',
          label: '已支付'
        }, {
          value: '2',
          label: '已取消'
        }, {
          value: '3',
          label: '手动核销'
        }, {
          value: '4',
          label: '扫码核销'
        }],
				Count:0,
				// options:[],
				ListData:[],
				total: 0,
				page: 0,
				listLoading: false,
                sels: [],//列表选中列	
                imgUrl:'',
				addFormVisible:false,	
				
				//扫码枪相关model
				Machine:false,
				inputValue:'',
				focusvalue:false,
			}
		},
		methods: {

		
			closeDialog(){
		      this.List();
           },
		ConsumptionBusiness(){
				this.inputValue='';
			  this.focusvalue=true;             
			  this.Machine=true;
			  this.onCellClick(event);
			},
			BusinessHandle()
			{									
				let para={
                    code:this.inputValue
				}
				this.inputValue='';
                SweepCode(para).then((res)=>{
 								let { Success,Msg } = res.data;
								if(Success)
								{
                                    
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
              }).catch(error=>{
                 alert('网络错误');
                });
			},
						//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},
				formatIsUse: function (row, column) {
				return row.IsUse == true ? '是' : row.IsUse == false ? '否' : '未知';
			},
              see(row){
                     this.imgUrl="data:image/jpeg;base64,"+row.Image;
                  this.addFormVisible=true;
              },
            verification(row){

				this.$confirm('确认核销这张订单吗？', '提示', {}).then(() => {
                let para={
                    id:row.Id
                }
                TicketOrderChangeState(para).then((res)=>{
 								let { Success,Msg } = res.data;
								if(Success)
								{
                                    row.OrderState=3;
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
              }).catch(error=>{
                 alert('网络错误');
                });
				})
              
            },
        //    SwitchChange(row){
        //         // console.log(1);
		// 	   row.State=row.BoolState==true?0:1;			 
        //         let para={
        //             id:row.Id
        //         }
        //       TicketOrderChangeState(para).then((res)=>{
        //       }).catch(error=>{
        //          alert('网络错误');
        //         });
        //     },

			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			// formatState: function (row, column) {
			// 	return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			// },
			
			handleCurrentChange(val) {
				this.page = val;
				this.List();
			},
			//获取用户列表
		
			List() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
                    MemberName:this.filters.Name,
                    OrderNumber:this.filters.OrderNumber,
                    OrderState:this.orderState,
				};
				this.listLoading = true;
				//NProgress.start();
				TicketOrderList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
					//  console.log(res);
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.ListData =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							
			
		
			
		
			selsChange: function (sels) {
				this.sels = sels;
			},

   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.List();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// TicketOrder.vue?22d01e60